import { Component, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Cancel01Icon } from '@hugeicons/core-free-icons/index';

export interface ConfirmationPopupData {
  title: string;
  message: string;
  confirmButtonText: string;
  cancelButtonText: string;
  confirmButtonType?: 'primary' | 'secondary' | 'secondary-neutral';
  cancelButtonType?: 'primary' | 'secondary' | 'secondary-neutral';
}

export interface ConfirmationPopupResult {
  confirmed: boolean;
}

@Component({
  selector: 'ptl-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss'],
})
export class ConfirmationPopupComponent {
  readonly Cancel01Icon = Cancel01Icon;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationPopupData,
  ) {}

  onClose(): void {
    this.dialogRef.close({ confirmed: false } as ConfirmationPopupResult);
  }

  onCancel(): void {
    this.dialogRef.close({ confirmed: false } as ConfirmationPopupResult);
  }

  onConfirm(): void {
    this.dialogRef.close({ confirmed: true } as ConfirmationPopupResult);
  }
}
